export class NoCodesAction {
    constructor(type, value, error) {
        this.type = type;
        this.value = value;
        this.error = error;
    }
}
//# sourceMappingURL=NoCodesAction.js.map